export namespace CertificatesModel {
  export interface Document {
    id: string;
    created: string;
    expires: string;
    status: CertificateType;
    common_name: string;
  }

  export interface RequestFilter {
    status: string;
    query: string;
  }

  export type UrlFiltersCriteria = {
    status: string;
    query: string;
  };

  export enum CertificateType {
    DRAFT = 'draft',
    PENDING_VALIDATION = 'pending_validation',
    ISSUED = 'issued',
    EXPIRING_SOON = 'expiring_soon',
    CANCELLED = 'cancelled',
    REVOKED = 'revoked',
    EXPIRED = 'expired',
  }

  export const certificateTypeStr: { [Property in CertificateType]: string } = {
    [CertificateType.DRAFT]: 'EDGE_CERTIFICATE.STATUS.DRAFT',
    [CertificateType.PENDING_VALIDATION]: 'EDGE_CERTIFICATE.STATUS.PENDING_VALIDATION',
    [CertificateType.ISSUED]: 'EDGE_CERTIFICATE.STATUS.ISSUED',
    [CertificateType.EXPIRING_SOON]: 'EDGE_CERTIFICATE.STATUS.EXPIRING_SOON',
    [CertificateType.CANCELLED]: 'EDGE_CERTIFICATE.STATUS.CANCELED',
    [CertificateType.REVOKED]: 'EDGE_CERTIFICATE.STATUS.REVOKED',
    [CertificateType.EXPIRED]: 'EDGE_CERTIFICATE.STATUS.EXPIRED',
  };

  export const PAGE_LIMIT = 100;

  export namespace API {
    export interface Response {
      total_count: number;
      result_count: number;
      page: string;
      limit: number;
      acmeUsageLevel: string;
      acmeLocked: boolean;
      results: CertificatesModel.Document[];
    }
  }
}
